import { createAsyncThunk } from '@reduxjs/toolkit'
import { CarshareApiService } from 'src/apis/CarshareApiService'
import { CostCentre } from 'src/types/CostCentre'
import { replaceAllCostCentres } from '../reducers/costCentres'

export const setupCostCentres = createAsyncThunk('costCentres/setup', async (_, { dispatch }) => {
  const costCentres = await CarshareApiService.get<CostCentre>('getCostCentres', {})

  if (costCentres.results) {
    dispatch(replaceAllCostCentres(costCentres.results))
  }
})
